import {useChats} from '../use-chats';
import {useAuth} from '@common/auth/use-auth';
import {Trans} from '@common/i18n/trans';
import React, {Fragment, ReactNode, useEffect, useState} from 'react';
import {useTrans} from '@common/i18n/use-trans';
import {message} from '@common/i18n/message';
import {Footer} from '@common/ui/footer/footer';
import {AnimatePresence, m} from 'framer-motion';
import {DashboardNavbar} from '@app/dashboard/dashboard-navbar';
import {useAccountUsage} from '@app/editor/use-account-usage';
import {AdHost} from '@common/admin/ads/ad-host';
import {StaticPageTitle} from '@common/seo/static-page-title';
import { ChatsIndexPage } from './chats-index-page';
import { CreateChatPage } from '@app_modules/admin/chats/crupdate-chat-page/create-chat-page';
import { EditChatPage } from '@app_modules/admin/chats/crupdate-chat-page/edit-chat-page';
import { ChatViewPage } from './chat-view-page';
import { ChatNowPage } from '@app_modules/admin/chats/crupdate-chat-page/chat-now-page';
import ChatBotWidget from './chat-bot-widget';
import { apiClient } from '@common/http/query-client';
import { UWPage } from '@app_modules/admin/chats/crupdate-chat-page/uw-page';
import { useSettings } from '@common/core/settings/use-settings';
import { useIsDarkMode } from '@common/ui/themes/use-is-dark-mode';
import { UwDemoPage } from './uw-demo-page';
import { ChatLendermacDemoPage } from './chat-lendermac-demo-page';

const SortOptions = [
  {value: 'created_at|desc', label: message('Date created')},
  {value: 'name|asc', label: message('Alphabetical')},
  {value: 'updated_at|desc', label: message('Last updated')},
];

export function ChatPage() {
  const {data: usage} = useAccountUsage();
  const {trans} = useTrans();
  const {user} = useAuth();
  const query = useChats({userId: user!.id, paginate: 'lengthAware'});
  const {sortDescriptor, setSortDescriptor, searchQuery, setSearchQuery} =
    query;
  const sortValue = `${sortDescriptor.orderBy}|${sortDescriptor.orderDir}`;

  return (
    <Fragment>
      <StaticPageTitle>
        <Trans message="Chat" />
      </StaticPageTitle>
      <div className="flex h-screen flex-col overflow-y-scroll">
        {/* <DashboardNavbar /> */}
        <div className="items-center gap-12 py-361">
          <div className='mr-auto'>
          <AdHost slot="dashboard_top" className="mb-36" />
          <AnimatePresence initial={false} mode="wait">
            <ChatsIndexPage/>

          </AnimatePresence>
          <AdHost slot="dashboard_bottom" className="mt-36" />
          </div>
        </div>
        
        <Footer className="mt-40 px-40" />
      </div>
    </Fragment>
  );
}

export function NewChatPage() {
  return (
    <div>
      <StaticPageTitle>
        <Trans message="New Chat" />
      </StaticPageTitle>
      {/* <DashboardNavbar /> */}
      <div className="container mx-auto mt-40 px-20">
        <CreateChatPage callback_url="/chats"/>
        <Footer />
      </div>
    </div>
  );
}


export function UpdateChatPage() {
  return (
    <div>
      <StaticPageTitle>
        <Trans message="Edit Chat" />
      </StaticPageTitle>
      {/* <DashboardNavbar /> */}
      <div className=" mt-40 px-20">
        <EditChatPage callback_url="/chats"/>
        <Footer />
      </div>
    </div>
  );
}

export function ViewChatPage() {
  return (
    <div>
      <StaticPageTitle>
        <Trans message="View Chat" />
      </StaticPageTitle>
      {/* <DashboardNavbar /> */}
      <div className=" mt-40 px-20">
        <ChatViewPage callback_url="/chats"/>
        <Footer />
      </div>
    </div>
  );
}


export function ChatDemoPage() {
  const [lenderId, setLenderId] = useState();

  const changeLender = (lender: any) => {
    setLenderId(lender);
  }
  return (
    <div>
      <StaticPageTitle>
        <Trans message="New Chat" />
      </StaticPageTitle>
      {/* <DashboardNavbar /> */}
      <div className=" mx-auto px-20">
        <ChatNowPage changeLender={changeLender}/>
        
        {lenderId ? (<ChatBotPage lender_id={lenderId}/>):(<></>)}
        <Footer />
      </div>
    </div>
  );
}


export function UWDemoPage() {
  const [lenderId, setLenderId] = useState();

  const changeLender = (lender: any) => {
    setLenderId(lender);
  }

  return (
    <div>
      <StaticPageTitle>
        <Trans message="Under Writing" />
      </StaticPageTitle>
      {/* <DashboardNavbar /> */}
      <div className=" mx-auto px-20">
        <UWPage changeLender={changeLender}/>
        
        <Footer />
      </div>
    </div>
  );
}


export function UWLendermacPage() {
  const [lenderId, setLenderId] = useState();

  // const {
  //   branding: {logo_light, logo_dark},
  // } = useSettings();
  // const isDarkMode = useIsDarkMode();
  // const logoSrc = isDarkMode ? logo_light : logo_dark;

  const {uw} = useSettings();
  const logoSrc = uw?.uw_logo;

  const changeLender = (lender: any) => {
    setLenderId(lender);
  }

  return (
    <div className='w-full'>
      <div className='flex  mx-auto px-20 text-left'>
      {logoSrc && (
          <img
            src={logoSrc}
            alt="Site logo"
            className="mb-44 block h-100 w-auto"
          />
        )}
      </div>
      {/* <StaticPageTitle>
        <Trans message="Under Writing" />
      </StaticPageTitle> */}

      
      {/* <DashboardNavbar /> */}
      <div className=" mx-auto px-20">
        <UwDemoPage/>
        {/* <UWPage changeLender={changeLender}/> */}
        
        {/* <Footer /> */}
      </div>
    </div>
  );
}

export function ChatLendermacPage() {
  const [lenderId, setLenderId] = useState();

  const {
    branding: {logo_light, logo_dark},
  } = useSettings();
  const isDarkMode = useIsDarkMode();
  const logoSrc = isDarkMode ? logo_light : logo_dark;

  const changeLender = (lender: any) => {
    setLenderId(lender);
  }

  return (
    <div className='w-full'>
      <div className='flex  mx-auto px-20 text-left'>
      {logoSrc && (
          <img
            src={logoSrc}
            alt="Site logo"
            className="mb-44 block h-100 w-auto"
          />
        )}
      </div>
      {/* <StaticPageTitle>
        <Trans message="Under Writing" />
      </StaticPageTitle> */}

      
      {/* <DashboardNavbar /> */}
      <div className=" mx-auto px-20">
        <ChatLendermacDemoPage/>
        {/* <UWPage changeLender={changeLender}/> */}
        
        {/* <Footer /> */}
      </div>
    </div>
  );
}



export function ChatBotPage({lenderId}: any) {
  const {trans} = useTrans();
  const [messages, setMessages] = useState<any[]>([
    {
      role: "assistant",
      content: "hi! Can I help you?",
    }
  ]);


  const customApiCall = async (message: string): Promise<string> => {
    const response = await apiClient.post(`chats/demo`, {prompt: message, lender_id: lenderId}).then(r => r.data);
    return response.data;
  };

  const handleBotResponse = (response: string) => {
    // Handle the bot's response here
    // console.log("Bot Response:", response);
    setMessages((prevMessages) => [
      ...prevMessages,
      { role: "assistant", content: response },
    ]);
  };

  const handleNewMessage = (message: any) => {
    setMessages((prevMessages) => [...prevMessages, message]);
  };

  return (
    <div>
      <ChatBotWidget
          callApi={customApiCall}
          onBotResponse={handleBotResponse}
          handleNewMessage={handleNewMessage}
          messages={messages}
          primaryColor="#3498db"
          inputMsgPlaceholder="Type your message..."
          chatbotName="Support"
          isTypingMessage="Typing..."
          IncommingErrMsg="Oops! Something went wrong. Try again."
          chatIcon={<div>AI</div>}
          botIcon={<div>B</div>}
          botFontStyle={{
            fontFamily: "Arial",
            fontSize: "14px",
            color: "red",
          }}
          typingFontStyle={{
            fontFamily: "Arial",
            fontSize: "12px",
            color: "#888",
            fontStyle: "italic",
          }}
        />
    </div>
  );
}


